import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { format } from 'date-fns';
import 'react-toastify/dist/ReactToastify.css';

export type ToastProps = {
    text: string;
    secondaryText?: string;
    type?: 'success' | 'error' | 'info' | 'warning';
    showTimestamp?: boolean;
};

export const showAppToast = ({ text, secondaryText, type = 'info', showTimestamp = true }: ToastProps) => {
    const timestamp = format(new Date(), 'M/d/yyyy h:mm:ssaaa');
    toast(
        <div>
            <div>{text}</div>
            {secondaryText && <div className="text-xs text-gray-500">{secondaryText}</div>}
            {showTimestamp && (
                <div className="text-xs text-gray-400 mt-1">Completed at {timestamp}</div>
            )}
        </div>,
        { type }
    );
};

const Toast: React.FC = () => <ToastContainer position="bottom-right" />;

export default Toast;
